import React, { useState, useEffect, useRef } from "react";

import {
  Col,
  Card,
  CardBody,
  Container,
  Row,
  Input,
  Label,
  Badge,
  Button,
  Modal,
} from "reactstrap";
import { Link } from "react-router-dom";

import { useForm } from "react-hook-form";
import Swal from "sweetalert2";




import SearchTable from "components/shared/SearchTable/SearchTable";
import { useNavigate, useParams } from "react-router-dom";

import api from "../../../services/api";

const Gateway = () => {
  const [allEquipamentos, setAllEquipamentos] = useState([]);
  const [equipamento, setEquipamento] = useState([]);
  const [fabricantes, setFabricantes] = useState();

  const [selectedFabricante, setSelectedFabricante] = useState("");
  const [codigo, setcodigo] = useState("");
  const [tipo, settipo] = useState("");
  const [nome, setNome] = useState("");
  const [numeroLoras, setNumeroLoras] = useState("");

  const [totLora, setTotLora] = useState("");
  const [parcialLoras, setParcialLoras] = useState("");
  const [selectedEquipamento, setSelectedEquipamento] = useState([]);
  const [selcetAll, setSelcetAll] = useState(false);
  const [todos, setTodos] = useState([]);
  
  const [check, setCheck] = useState(false);
      const [showPopup, setShowPopup] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  let navigate = useNavigate();
      
  useEffect(() => {
    let fabricante = [];
    let equip = [];
    let empresas = [];
    let totalLora = "";
    api
      .get("/gateway")
      .then((response) => {
        response.data.map((elem) => {
          fabricante.push({
            id: elem.OID_GATEWAY,
            nome: elem.DS_NOME,
            codigo: elem.DS_CODIGO,
            tipo: elem.TIPO,
          });
        });
        setFabricantes(fabricante);
      })
      
  }, []);

  useEffect(() => {
    if (selcetAll) {
      setSelectedEquipamento(todos);
    } else {
      setSelectedEquipamento([]);
    }
  }, [selcetAll]);

  const onSubmitRegister = () => {
    Swal.fire({
      icon: "warning",
      text: "Este Modulo possui um registro, para enviar dados, faça uma calibração!",
    });
    
    return;
  }

   const handleButtonClick = (number) => {
     // Prevent default form submission
    setSelectedNumber(number);
    setShowPopup(true);
  };

  const handleConfirm = () => {
    // Perform your function logic here
    console.log('Function executed with number:', selectedNumber);
    setShowPopup(false); 

    let bodyreg = {
      
      OID_GATEWAY: selectedNumber,
      
    }

    
        api.delete(`/gateway/${selectedNumber}`).then(() => {
          Swal.fire({
            icon: "success",
            title: "gateway deletado!",
          })
            .then(() => {
              navigate("/configuracao/gateway");
              window.location.reload(true)
            })
            .catch(() => {
              Swal.fire({
                icon: "warning",
                title: "Dados Inválidos!",
              });
            });
        });



  };

  const handleCancel = () => {
    setShowPopup(false); // Close the popup without executing the function
  };

  const { register, handleSubmit } = useForm();
  const onSubmit = () => {
    let selectedFabricanteId;
    fabricantes.map((elem) => {
      if (selectedFabricante === elem.name) {
        selectedFabricanteId = elem.id;
      }
    });

    let body = {
      DS_NOME: nome,
      DS_CODIGO: codigo,
      TIPO: tipo,
    };

     api.post("/gateway/filter", body)
    .then((response) => {
      if (response.data.length === 0) {
        setFabricantes([])
        Swal.fire({
          icon: "warning",
          text: "Nenhum resultado encontrado, refaça a sua busca!",
        });
        return;
      }

      const novosFabricantes = response.data.map(elem => ({
        id: elem.OID_GATEWAY,
        nome: elem.DS_NOME,
        codigo: elem.DS_CODIGO,
        tipo: elem.TIPO,
      }));

      setFabricantes(novosFabricantes);

      Swal.fire({
        icon: "success",
        timer: 500,
      });
    })
    .catch((error) => {
      // Optional: add error feedback
      console.error("Erro na requisição:", error);
    });
};

  const inputHandler = (prop) => (event) => {
    if (prop === "codigo") {
      setcodigo(event.target.value);
    } else if (prop === "tipo") {
      settipo(event.target.value);
    } else if (prop === "nome") {
      setNome(event.target.value);
    } else if (prop === "total") {
      if (event.target.checked == true) {
         setNumeroLoras(totLora);
        setCheck(true);
       
        
        setSelcetAll(true);
        
      } else {
        setNumeroLoras(parcialLoras);
        setSelcetAll(false);
        setCheck(false);
      }
    } else {
      let loras = numeroLoras;
      setCheck(false);
      if (selectedEquipamento.indexOf(event.target.value) > -1) {
        selectedEquipamento.splice(
          selectedEquipamento.indexOf(event.target.value),
          1
        );
      } else {
        selectedEquipamento.push(event.target.value);
      }

      if (loras.indexOf(event.target.value) > -1) {
        loras = loras.replace("-" + event.target.value, "");
      } else {
        loras += "-" + event.target.value;
      }
      setParcialLoras(loras);
      setNumeroLoras(loras);
    }
  };

  const selectHandler = (event) => {
    setSelectedFabricante(event.target.value);
  };

  // const formatArray = (data) => {
  //   let array = [];
  //   let totalLora = "";
  //   fabricantes.map((elem) => {
  //         array.push({
  //           id: elem.OID_GATEWAY,
  //           idFabricante: elem.OID_FABRICANTE_LORA,
  //           fabricanteName: elem.name,
  //           nome: elem.DS_MOME,
  //           tipo: elem.DS_tipo_EQUIPAMENTO,
  //           numero: elem.NR_EQUIPAMENTO,
  //           registro: elem.OID_REGISTRO,
  //         });
         
        
      
  //   });
  //   setTotLora(totalLora);

  //   return array;
  // };

  return (
    <React.Fragment>
      <div className="page-content">
       
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Gateways</h6>
               
              </Col>
            </Row>
          </div>
        </Container>

        <Row>
          <Col lg={12}>
           
            <Card>
             
              <CardBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="mb-3 align-items-center">

 <label
                      htmlFor="DS_codigoRICAO_EQUIPAMENTO"
                      className="col-md-2 col-form-label"
                    >
                      Nome
                    </label>
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-lg"
                        type="text"
                        name="DS_codigoRICAO_EQUIPAMENTO"
                        onChange={inputHandler("nome")}
                        value={nome}
                      />
                    </div>

    <div className="col-md-4 text-end">
    <Button
      color="primary"
      href="/configuracao/gateway-cadastro"
    >
      Cadastrar
    </Button>
  </div>
</Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="DS_codigoRICAO_EQUIPAMENTO"
                      className="col-md-2 col-form-label"
                    >
                      Codigo
                    </label>
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-lg"
                        type="text"
                        name="DS_codigoRICAO_EQUIPAMENTO"
                        onChange={inputHandler("codigo")}
                        value={codigo}
                      />
                    </div>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="DS_tipo_EQUIPAMENTO"
                      className="col-md-2 col-form-label"
                    >
                     Tipo
                    </label>
                    <div className="col-md-6">
                      <input
                        className="form-control form-control-lg"
                        type="text"
                        name="DS_tipo_EQUIPAMENTO"
                        onChange={inputHandler("tipo")}
                        value={tipo}
                      />
                    </div>
                  </Row>
                 
                  <Row className="mb-3">
                    <div className="button-items text-center">
                      <Button
                        color="secondary"
                        className="btn-lg"
                        type="submit"
                      >
                        Pesquisar <i className="dripicons-search" />
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Container fluid>
          <div className="table-responsive">
            <table className="table align-middle table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th className="align-middle">Nome Completo</th>
                  <th className="align-middle">Codigo</th>
                  <th className="align-middle">Tipo</th>
                  <th className="align-middle"></th>
                  <th className="align-middle"></th>
                 
                </tr>
              </thead>
              <tbody>
                {fabricantes?.map((equipamento, key) => (
                  <tr key={"_tr_" + key}>
                    <td>{equipamento.nome}</td>
                    <td>{equipamento.codigo}</td>
                    <td>{equipamento.tipo}</td>
                    {/* <td>{equipamento.numero}</td> */}
                    {/* <td>
                    {
                      (() => {
                        if(equipamento.registro != null){
                          return  <span className="badge bg-success">
													Possui Registro
												</span>
                        }
                      
                        if(equipamento.registro == null){
                         return <span className="badge bg-info bg-warning">
													Não Possui Registro
												</span>  
                        }
                      })()
                    }
                    </td> */}
                    <td className="d-flex align-items-center">
                   
                      <Link
                        type="button"
                        to={`/configuracao/Gateway-update/${equipamento.id}`}
                        color="link"
                        size="sm"
                        className="btn btn-light waves-effect waves-light"
                      >
                        Editar
                      </Link>
                    </td>
                    <td>
                            <i onClick={() => handleButtonClick(equipamento.id)} className="dripicons-trash" style={{ cursor: 'pointer' }} /> 
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
           {showPopup && (
            <div className="modal-overlay">
              <div className="modal-content2">
                <p>Você realmente deseja deletar o Gateway?</p>
                <div className="modal-buttons">
                  <button className="confirm-button" onClick={handleConfirm}>Sim</button>
                  <button className="cancel-button" onClick={handleCancel}>Não</button>
                </div>
              </div>
            </div>
          )}
      </div>
    </React.Fragment>
  );
};

export default Gateway;
